export default function paragraphFilter(text: any) {
  if (typeof text !== 'string') {
    return ''
  }

  return text.trim()
    .split(/[\r\n]+/)
    .reduce((html, paragraph) => `${html}<p>${paragraph.trim()}</p>`, '')
}
